module.exports=function(scope){ return `<!-- Enrolled successfully -->
<!-- faceMap value will return in response for return=faceMap passed in request -->
{
    "data": {
        "glasses": false,
        "sessionTokenStatus": 2,
        "faceMapType": 0,
        "createdDate": "2020-06-15T17:19:06.391Z",
        "livenessStatus": 0,
        "auditTrailVerificationCheck": 0,
        "isEnrolled": true,
        "isLowQuality": false,
        "auditTrailMatchCheck": 0,
        "isReplayFaceMap": false
    },
    "meta": {
        "code": 200,
        "message": "The FaceMap was successfully enrolled.",
        "ok": true,
        "m": {
            "prepareAndUpdateTimeInMS": ...,
            "totalDurationInMS": ...
        }
    }
}

<!-- Enrollment failed because Liveness could not be determined -->
{
    "data": {
        "glasses": false,
        "sessionTokenStatus": 2,
        "faceMapType": 0,
        "livenessStatus": 1,
        "auditTrailVerificationCheck": 1,
        "isEnrolled": false,
        "isLowQuality": false,
        "auditTrailMatchCheck": 1,
        "isReplayFaceMap": false
    },
    "meta": {
        "code": 200,
        "message": "The FaceMap was not enrolled because liveness could not be determined.",
        "ok": true,
        "m": {
            "prepareAndUpdateTimeInMS": ...,
            "totalDurationInMS": ...
        }
    }
}
`};


// WEBPACK FOOTER //
// ./src/resources/code/restsdk-v2/response/success/enrollment-post.json.tpl